<template>
  <v-app>
    <v-app-bar absolute app dark flat>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="headline text-uppercase fin">
        <span>C S : G O &nbsp;</span>
        <span class="font-weight-light">League</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" color="#303030" exact>
        <v-btn text :to="{ name: 'Home' }" exact>Home</v-btn>
        <v-btn text :to="{ name: 'Players' }" exact>Players</v-btn>
        <!-- <v-btn text :to="{ name: 'Teams' }" exact>Teams</v-btn> -->
        <v-btn text :to="{ name: 'Auction' }" exact>Auction</v-btn>
        <v-btn text :to="{ name: 'Announcements' }" exact>Announcements</v-btn>
        <v-btn text :to="{ name: 'Fixtures' }" exact>Fixtures</v-btn>
        <v-btn text :to="{ name: 'PointsTable' }" exact>Points Table</v-btn>
        <v-btn text :to="{ name: 'Rules'}" crossorigin="anonymous">Rules</v-btn>
        <v-btn text exact v-if="currentUser" @click="logout">LOGOUT</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-navigation-drawer dark v-model="drawer" absolute temporary>
      <v-list nav dense>
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'Home' }"
          exact
          >Home</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'Players' }"
          exact
          >Players</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'Teams' }"
          exact
          >Teams</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'Auction' }"
          exact
          >Auction</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'Announcements' }"
          exact
          >Announcements</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'Fixtures' }"
          exact
          >Fixtures</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          :to="{ name: 'PointsTable' }"
          exact
          >Points Table</v-list-item
        >
        <v-list-item
          active-class="grey--text text--accent-4"
          exact
          v-if="currentUser"
          @click="logout"
          >LOGOUT</v-list-item
        >
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view />
    </v-content>
    <v-footer padless absolute app class="lexend">
      <v-col class="text-center" cols="12">
        Made with
        <span class="fin">💚</span> by
        <span>
          <a class="upthrust" href="https://github.com/VAR-solutions"
            >UpThrust</a
          >
        </span>
        For
        <span class="fin">Arcadia</span>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
const fb = require("./firebaseConfig");
import { mapState } from "vuex";
export default {
  name: "App",
  data: () => ({
    drawer: null
  }),
  computed: {
    ...mapState(["currentUser"])
  },
  methods: {
    logout() {
      fb.auth.signOut().then(() => {
        this.$store.dispatch("clearData");
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style></style>
